import { Component, computed, inject, OnInit, resource, signal } from '@angular/core';
import { debounceTime, firstValueFrom } from 'rxjs';
import { NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { InputModule } from '@beautyapp/form';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { TranslateModule } from '@ngx-translate/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ErxService } from '@beautyapp/core';
import { rxResource } from '@angular/core/rxjs-interop';

@UntilDestroy()
@Component({
  selector: 'lib-drug-list',
  imports: [
    NzTableModule,
    InputModule,
    NzSpaceModule,
    TranslateModule,
    NzFormModule,
    ReactiveFormsModule,
    FormsModule,
    NzButtonModule,
    NzIconModule,
    NzPopoverModule
],
  templateUrl: './drug-list.component.html',
  styleUrl: './drug-list.component.scss'
})
export class DrugListComponent implements OnInit {

  erxService = inject(ErxService);
  modal = inject(NzModalRef);

  searchForm: FormGroup = new FormGroup({
    search: new FormControl(''),
    generic: new FormControl(''),
    actElement: new FormControl('')
  });

  page = signal(1);
  pageSize = signal(10);
  search = signal('');
  generic = signal('');
  actElement = signal('');

  drugResources = rxResource({
    params: () => ({
      page: this.page(),
      pageSize: this.pageSize(),
      search: this.search(),
      generic: this.generic(),
      actElement: this.actElement()
    }),
    stream: ({ params }) => this.erxService.getDrugPagination({
      page: params.page,
      pageSize: params.pageSize,
      search: params.search,
      generic: params.generic,
      actElement: params.actElement
    })
  });

  drugs = computed(() => this.drugResources.value()?.data || []);
  totalItems = computed(() => this.drugResources.value()?.meta?.itemCount || 0);
  loading = computed(() => this.drugResources.isLoading());


  ngOnInit() {
    this.searchForm.valueChanges
      .pipe(
        untilDestroyed(this),
        debounceTime(500)
      )
      .subscribe(value => {
        this.search.set(value.search || '');
        this.generic.set(value.generic || '');
        this.actElement.set(value.actElement || '');
        this.page.set(1);
      });
  }

  clearSearch() {
    this.searchForm.reset();
    this.search.set('');
    this.generic.set('');
    this.actElement.set('');
    this.page.set(1);
  }

  paginatorChange($event: NzTableQueryParams) {
    this.page.set($event.pageIndex);
    this.pageSize.set($event.pageSize);
  }

  productSelected(row: any) {
    this.modal.close(row);
  }
}
